'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _buildVideoLinks2 = require('../../../utils/buildVideoLinks');var _buildVideoLinks3 = _interopRequireDefault(_buildVideoLinks2);
var _ImageGallery = require('./ImageGallery');var _ImageGallery2 = _interopRequireDefault(_ImageGallery);
var _PropertyDetails = require('./PropertyDetails.scss');var styles = _interopRequireWildcard(_PropertyDetails);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /* eslint-disable jsx-a11y/media-has-caption */

var GalleryPreview = function GalleryPreview(_ref)







{var _cx;var openLightbox = _ref.openLightbox,images = _ref.images,children = _ref.children,videoTour = _ref.videoTour,screenWidth = _ref.screenWidth,isMobile = _ref.isMobile,openVideo = _ref.openVideo;
  var renderVideo = function renderVideo() {
    if (!videoTour) {return null;}var _buildVideoLinks =

    (0, _buildVideoLinks3.default)(videoTour),thumbnail = _buildVideoLinks.thumbnail,full = _buildVideoLinks.full;
    return (
      _react2.default.createElement(_ImageGallery2.default, {
          onClick: openVideo,
          className: styles.propertyGallery },

        _react2.default.createElement('video', {
            controls: true,
            poster: thumbnail,
            width: isMobile ? screenWidth : 915,
            height: isMobile ? 281 : 550 },

          _react2.default.createElement('source', { src: full + '.mp4', type: 'video/mp4' }),
          _react2.default.createElement('source', { src: full + '.ogv', type: 'video/ogv' }),
          _react2.default.createElement('source', { src: full + '.webm', type: 'video/webm' })),

        children));


  };

  return (
    _react2.default.createElement('div', {
        className: (0, _classnames2.default)(styles['gallery-' + images.length], (_cx = {}, _cx[
        styles.propertyGalleryWrapper] = !!images.length, _cx[
        styles.propertyVideoWrapper] = !images.length && !!videoTour, _cx)) },


      !images.length && !!videoTour && renderVideo(),
      !!images.length && images.map(function (image, index) {var _cx2;
        var isLastImage = images.length === index + 1;
        return (
          _react2.default.createElement(_ImageGallery2.default, {
              index: index,
              onClick: openLightbox,
              key: image.gallery,
              className: (0, _classnames2.default)(
              styles.propertyGallery, (_cx2 = {}, _cx2[
              styles.lastPropertyGallery] = isLastImage, _cx2)) },


            _react2.default.createElement('img', { src: image.gallery, alt: '' }),
            isLastImage && children));


      })));


};

GalleryPreview.propTypes = {
  images: _propTypes2.default.array.isRequired,
  videoTour: _propTypes2.default.array,
  openLightbox: _propTypes2.default.func.isRequired,
  openVideo: _propTypes2.default.func,
  children: _propTypes2.default.element,
  isMobile: _propTypes2.default.bool,
  screenWidth: _propTypes2.default.number };exports.default =


GalleryPreview;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/PropertyDetails/GalleryPreview.js
// module id = 2817
// module chunks = 0